import Swiper from 'swiper/bundle';
import SimpleLightbox from "simplelightbox";

// import styles bundle
import 'swiper/css/bundle';

/* swiper */
const swiper = document.querySelectorAll('[data-swiper]');

swiper.forEach(function (element) {
    const settings = JSON.parse(element.dataset.swiper);

    new Swiper(element, settings);
});

/* shop detail */
var swiper_shop_thumb = new Swiper(".shop-thumb-swiper", {
        slidesPerView: 6,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
      });

var swiper_shop = new Swiper(".shop-swiper", {
        slidesPerView: 1,
        resizeObserver: true,
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: swiper_shop_thumb,
        },
      });

/* ligthbox */
const lb_gallery_div = document.querySelector('.lightbox-gallery');

function shop_slide_to(hash_string, shop_slider){
  var hash_id = hash_string.replace('#pid=', '');
  hash_id = parseInt(hash_id);
  // to do - prev hash-1
  shop_slider.slideTo(hash_id, 0, false);
}

new SimpleLightbox('.lightbox_image');
//new SimpleLightbox('.lightbox_video');
var slider_index;

if (lb_gallery_div) {
  // gallery allgemein
  let lb_gallery = new SimpleLightbox('.lightbox-gallery a', {
              navText: ['←','→'],
              captionType: 'data',
              captionsData: 'caption',
              captionPosition: 'outside'
          });
  // bei shop swiper index anpassen
  if (swiper_shop) {
    lb_gallery.on('nextImageLoaded.simplelightbox', function (e) {
      slider_index = e.currentTarget.dataset.counter;
      //var hash_string = window.location.hash;
      shop_slide_to(slider_index, swiper_shop);
    });
    lb_gallery.on('prevImageLoaded.simplelightbox', function (e) {
      slider_index = e.currentTarget.dataset.counter;
      //var hash_string = window.location.hash;
      shop_slide_to(slider_index, swiper_shop);
    });
  }
}